import type { BaseQueryError } from "@shared/types/baseQueryError";

const isBaseQueryError = (error: unknown): error is BaseQueryError => {
    return (error as BaseQueryError).message !== undefined
}

export default isBaseQueryError